import React from 'react';

import * as S from './styles';

import { ProductCorePropertiesProps } from './types';

const ProductCoreProperties = ({
  className,
  properties,
  toneDown,
  maxrows,
  size,
  showAsList,
  truncate,
}: ProductCorePropertiesProps) => (
  <S.PropertyList
    className={className}
    toneDown={toneDown}
    maxRows={maxrows}
    size={size}
    showAsList={showAsList}
  >
    {properties ? (
      properties
        .filter(v => v)
        .map(value => (
          <S.Property key={value} showAsList={showAsList} truncate={truncate}>
            {value}
          </S.Property>
        ))
    ) : (
      <S.PlaceholderProperty toneDown={toneDown} size={size} />
    )}
  </S.PropertyList>
);

ProductCoreProperties.defaultProps = {
  properties: undefined,
  toneDown: false,
  maxrows: undefined,
  size: 'large',
  showAsList: false,
  className: undefined,
  truncate: false,
};

export default ProductCoreProperties;
